'use client';
import { Box, TableCell } from '@mui/material';
import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

const TableActionCell = ({ children }: Props) => {
  return (
    <TableCell align="right">
      <Box onClick={e => e.stopPropagation()}>{children}</Box>
    </TableCell>
  );
};

export default TableActionCell;
